const mrpOportunityHeader = [
  {
    group: 'Descrição',
    id: 'descricao'
  },
  {
    group: 'Meses',
    columns: Array.from({ length: 12 }, (_, k) => ({
      id: `meses-${k + 1}`,
      name: `${k + 1} º`,
      show: true
    }))
  }
]

export default mrpOportunityHeader
